import { Controller } from 'stimulus';
import events from 'lib/events';

const klaviyoEventsListOnce = [
  events.download_btn.initial_click,
  events.download_btn.match_eezycore_free_dupe,
  events.errors.error404_page,
  events.locale_prompt.locale_prompt_accepted,
  events.locale_prompt.locale_prompt_connects,
  events.locale_prompt.locale_prompt_dismissed,
  events.locale_prompt.switch_language,
  events.search.without_results,
  events.search.trending_search_click,
  events.sessions.new_account_created,
  events.show_page.download_ad_modal_connects,
  events.show_page.download_limit_modal_connects,
  events.show_page.license_selector_free_modal_closes,
  events.show_page.license_selector_free_modal_connects,
  events.show_page.license_selector_free_modal_free_button,
  events.show_page.license_selector_free_modal_learn_more,
  events.show_page.license_selector_free_modal_pro_button,
  events.site_header.header_join_pro,
  events.site_header.header_login,
  events.site_header.header_signup,
  events.sponsored_search.without_results,
  events.checkout.error,
  events.partner.pagination_popup,
  events.partner.search_popup,
];

const klaviyoEventsListAlways = [
  events.search.filter,
  events.show_page.attribution_link_copied,
  events.site_header.related_tag_click,
  events.partner.results_click,
];

export default class KlaviyoAnalyticsController extends Controller {
  connect() {
    this.installScript();

    window._learnq = window._learnq || []; /* eslint-disable-line no-underscore-dangle */

    if (!this.isTurbolinksPreview) {
      this.identifyUser();
      this.trackPageView();
      if (this.currentPageType === 'Show Page') { this.trackKlaviyoViewedResource(); }
    }

    this.removeListeners(klaviyoEventsListOnce, { once: true });
    this.removeListeners(klaviyoEventsListAlways, { once: false });
    this.registerListeners(klaviyoEventsListOnce, { once: true });
    this.registerListeners(klaviyoEventsListAlways, { once: false });
  }

  disconnect() {
    this.removeListeners(klaviyoEventsListOnce, { once: true });
    this.removeListeners(klaviyoEventsListAlways, { once: false });
  }

  installScript() {
    const script = document.createElement('script');
    script.type = 'application/javascript';
    script.async = 1;
    script.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${this.companyId}`;
    document.body.appendChild(script);
  }

  identifyUser() {
    const user = {
      $email: this.userEmail,
      $first_name: this.userFirstName,
      $last_name: this.userLastName,
    };

    this.push(['identify', user]);
  }

  push(...args) {
    window._learnq.push(...args); /* eslint-disable-line no-underscore-dangle */
  }

  trackEvent = (event) => {
    this.push(['track', event.type, { url: window.location.href, ...event.detail }]);
  }

  trackPageView() {
    this.push(['track', 'pageview', { url: window.location.href }]);
  }

  registerListeners(eventsList, options) {
    eventsList.forEach((eventName) => {
      window.addEventListener(eventName, this.trackEvent, options);
    });
  }

  removeListeners(eventsList, options) {
    eventsList.forEach((eventName) => {
      window.removeEventListener(eventName, this.trackEvent, options);
    });
  }

  trackKlaviyoViewedResource() {
    this.push(['track', 'Viewed Resource', this.klaviyoAnalytics]);
  }

  get companyId() {
    return this.element.getAttribute('data-company-id');
  }

  get userEmail() {
    return this.element.getAttribute('data-email');
  }

  get userFirstName() {
    return this.element.getAttribute('data-first-name');
  }

  get userLastName() {
    return this.element.getAttribute('data-last-name');
  }

  get isTurbolinksPreview() {
    return document.documentElement.hasAttribute('data-turbolinks-preview');
  }

  get currentPageType() {
    return this.element.getAttribute('data-page-type');
  }

  get klaviyoAnalytics() {
    const analyticsValue = JSON.parse(this.element.getAttribute('data-klaviyo-analytics'));
    return analyticsValue;
  }
}
